const states = [
  {
    name: "Alabama",
    code: "US%3AAL"
  },
  {
    name: "Alaska",
    code: "US%3AAK"
  },
  {
    name: "American Samoa",
    code: "US%3AAS"
  },
  {
    name: "Arizona",
    code: "US%3AAZ"
  },
  {
    name: "Arkansas",
    code: "US%3AAR"
  },
  {
    name: "California",
    code: "US%3ACA"
  },
  {
    name: "Colorado",
    code: "US%3ACO"
  },
  {
    name: "Connecticut",
    code: "US%3ACT"
  },
  {
    name: "Delaware",
    code: "US%3ADE"
  },
  {
    name: "District Of Columbia",
    code: "US%3ADC"
  },
  {
    name: "Federated States Of Micronesia",
    code: "US%3AFM"
  },
  {
    name: "Florida",
    code: "US%3AFL"
  },
  {
    name: "Georgia",
    code: "US%3AGA"
  },
  {
    name: "Guam",
    code: "US%3AGU"
  },
  {
    name: "Hawaii",
    code: "US%3AHI"
  },
  {
    name: "Idaho",
    code: "US%3AID"
  },
  {
    name: "Illinois",
    code: "US%3AIL"
  },
  {
    name: "Indiana",
    code: "US%3AIN"
  },
  {
    name: "Iowa",
    code: "US%3AIA"
  },
  {
    name: "Kansas",
    code: "US%3AKS"
  },
  {
    name: "Kentucky",
    code: "US%3AKY"
  },
  {
    name: "Louisiana",
    code: "US%3ALA"
  },
  {
    name: "Maine",
    code: "US%3AME"
  },
  {
    name: "Marshall Islands",
    code: "US%3AMH"
  },
  {
    name: "Maryland",
    code: "US%3AMD"
  },
  {
    name: "Massachusetts",
    code: "US%3AMA"
  },
  {
    name: "Michigan",
    code: "US%3AMI"
  },
  {
    name: "Minnesota",
    code: "US%3AMN"
  },
  {
    name: "Mississippi",
    code: "US%3AMS"
  },
  {
    name: "Missouri",
    code: "US%3AMO"
  },
  {
    name: "Montana",
    code: "US%3AMT"
  },
  {
    name: "Nebraska",
    code: "US%3ANE"
  },
  {
    name: "Nevada",
    code: "US%3ANV"
  },
  {
    name: "New Hampshire",
    code: "US%3ANH"
  },
  {
    name: "New Jersey",
    code: "US%3ANJ"
  },
  {
    name: "New Mexico",
    code: "US%3ANM"
  },
  {
    name: "New York",
    code: "US%3ANY"
  },
  {
    name: "North Carolina",
    code: "US%3ANC"
  },
  {
    name: "North Dakota",
    code: "US%3AND"
  },
  {
    name: "Northern Mariana Islands",
    code: "US%3AMP"
  },
  {
    name: "Ohio",
    code: "US%3AOH"
  },
  {
    name: "Oklahoma",
    code: "US%3AOK"
  },
  {
    name: "Oregon",
    code: "US%3AOR"
  },
  {
    name: "Palau",
    code: "US%3APW"
  },
  {
    name: "Pennsylvania",
    code: "US%3APA"
  },
  {
    name: "Puerto Rico",
    code: "US%3APR"
  },
  {
    name: "Rhode Island",
    code: "US%3ARI"
  },
  {
    name: "South Carolina",
    code: "US%3ASC"
  },
  {
    name: "South Dakota",
    code: "US%3ASD"
  },
  {
    name: "Tennessee",
    code: "US%3ATN"
  },
  {
    name: "Texas",
    code: "US%3ATX"
  },
  {
    name: "Utah",
    code: "US%3AUT"
  },
  {
    name: "Vermont",
    code: "US%3AVT"
  },
  {
    name: "Virgin Islands",
    code: "US%3AVI"
  },
  {
    name: "Virginia",
    code: "US%3AVA"
  },
  {
    name: "Washington",
    code: "US%3AWA"
  },
  {
    name: "West Virginia",
    code: "US%3AWV"
  },
  {
    name: "Wisconsin",
    code: "US%3AWI"
  },
  {
    name: "Wyoming",
    code: "US%3AWY"
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/data/states.js